import React from "react";
import Section from "@atoms/Section/Section";
import Button from "@atoms/Button/Button";
import TitleGroup from "@atoms/TitleGroup/TitleGroup";
import MarkdownText from "@atoms/MarkdownText/MarkdownText";
import ResponsiveImg from "@atoms/ResponsiveImg";
import CardGrid from "../CardGrid/CardGrid";
import CoachVsTherapyCard from "../CoachVsTherapy/CoachVsTherapyCard";
import "./TherapyOrCoach.scss";
import { AnalyticsEventType } from "../../context/TrackingProvider";
import { useTracking } from "../../hooks";

const TherapyOrCoach = ({ data }) => {
	const { title, cards } = data;
	const { track } = useTracking();
	
	return (
		<div className="TherapyOrCoach">
			<Section container="large" spacingTop="m" spacingBottom="l">
				<Section spacingBottom="s">
					<TitleGroup align="desktopCenter" title={title} />
				</Section>
				<CardGrid size="2">
					{cards.map((item: any) => (
						<CoachVsTherapyCard
							key={item.id}
							title={item.title}
							subtitle={item.subtitle}
							image={
								<ResponsiveImg
									className="TherapyOrCoach--image"
									desktopImage={item.image ? item.image?.url : undefined}
								/>
							}
							cta={
								<a href={item.cta.to} onClick={() => {
									track({
										eventType: AnalyticsEventType.GButtonClick,
										data: {
											buttonName: item.cta.label,
											sourceUrl: window.location.pathname,
											targetUrl: item.cta.to,
										},
									});
								}}>
									<Button label={item.cta.label} />
								</a>
							}
						>
							<MarkdownText content={item.content} />
						</CoachVsTherapyCard>
					))}
				</CardGrid>
			</Section>
		</div>
	);
};

export default TherapyOrCoach;
